module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_7-ba12beb8ca24aa145f27eb20f3f67f4f.png";